import axios from 'axios'

export const uploadPublicFile = async (apiURL: string, file: File) => {
  const formData = new FormData()
  formData.append('attachment[file]', file)

  const response = await axios({
    method: 'post',
    url: `${apiURL}/api/v1/public_attachments`,
    data: formData,
  })

  return response.data.data
}
